import client from '../../../common/client';

export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const REFER_A_FRIEND = 'REFER_A_FRIEND';

export const getDashboardData = userId => ({
  promise: client.get(`users/${userId}/dashboard-data`),
  type: GET_DASHBOARD_DATA,
});

export const resetDashboardData = () => ({
  type: `${GET_DASHBOARD_DATA}_RESET`,
});

export const referAFriend = payload => ({
  promise: client.post('refer-a-friend', payload),
  type: REFER_A_FRIEND,
});



// WEBPACK FOOTER //
// ./src/subscription/dashboard/redux/actions.js